import { collection, addDoc, Timestamp } from 'firebase/firestore';
import { db } from '../../config';
import { fileExportProcessingStatus, fileExportStatus } from '../../../../constants/enum';

/**
 * ファイル出力履歴作成のパラメータ
 */
export interface CreateFileExportHistoryParams {
  pattern_id: string;
  pattern_name: string;
  company_id: string;
  file_name: string;
  file_type: 'csv' | 'xlsx';
  created_by: string;
  created_by_name: string;
  created_by_icon_url: string;
  is_proxy?: boolean;
}

/**
 * ファイル出力履歴を作成（processing_status: 1 = 出力中）
 * フロントエンドから直接Firestoreに書き込む
 */
export const createFileExportHistory = async (
  params: CreateFileExportHistoryParams,
): Promise<string> => {
  const docRef = await addDoc(collection(db, 'fileExportHistory'), {
    ...params,
    file_path: '', // 後でCloud Functionsが更新
    file_size: 0, // 後でCloud Functionsが更新
    processing_status: fileExportProcessingStatus.processing, // 出力中
    status: fileExportStatus.active, // 有効
    created_at: Timestamp.now(),
    updated_at: Timestamp.now(),
  });

  return docRef.id;
};
